export const splitByLength = <T extends { length: number, slice(start: number, end: number): T }>(arr: T, length: number): T[] => {
    const split: T[] = []

    for (let i = 0; i < arr.length; i += length) {
        split.push(arr.slice(i, i + length))
    }

    return split
}
